import {exec} from "child_process";
import * as fs from 'fs';

export class Npm {
  constructor(
    private readonly npmCommand: string,
    private readonly packageJsonPath: string
  ){}

  updateLibrary(library: string, version: string): Promise<void> {
    return new Promise((res, rej) => {

      const npmCommand = this.npmCommand;

      exec(`${npmCommand} uninstall ${library}`, function (err, stdout, stderr) {
        console.log(stdout);
        if(err){
          console.error(stderr);
          rej(err);
          return
        }
        exec(`${npmCommand} i ${library}@${version}`, function (err, stdout, stderr) {
          console.log(stdout);

          if(err){
            console.error(stderr);
            rej(err)
          }
          res();
        });
      })
    })

  }

  currentCarestreamServerVersion(): string {
    const packageJson = JSON.parse(fs.readFileSync(this.packageJsonPath, 'utf-8'));
    return packageJson['version']
  }

}
